import src from "IMAGE";
export default { src, width: 450, height: 257, blurWidth: 0, blurHeight: 0};
